import { render } from "./StructureItem.vue?vue&type=template&id=74afc3cc&scoped=true&ts=true"
import script from "./StructureItem.vue?vue&type=script&lang=ts"
export * from "./StructureItem.vue?vue&type=script&lang=ts"

import "./StructureItem.vue?vue&type=style&index=0&id=74afc3cc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74afc3cc"]])

export default __exports__